import { Box, TabPanel } from "@chakra-ui/react";
import Comment from "@src/components/widgets/Modals/ModalCommunication/components/comment/Comment";
import { CommentAppearance } from "@src/components/widgets/Modals/ModalCommunication/components/comment/CommentAppearance";
import type { UserType } from "@src/stores/models/Me";
import { useStore } from "@src/utils/hooks";
import useIntersectionObserver from "@src/utils/hooks/useIntersectionObserver";
import { observer } from "mobx-react-lite";
import { useRef } from "react";

export type CommunicationTabProps = {
  userType: UserType;
};

const USER_TYPE_TO_COLOR_SCHEME_MAP = {
  client: "pink",
  internal: "grey",
  partner: "blue",
} as const;

export const CommunicationTab = observer(function CommunicationTab({
  userType,
}: CommunicationTabProps) {
  const { taskDetailModalStore: store } = useStore();
  const firstCommentRef = useRef(null);

  const { userTypesWithAccess } =
    store.communicationTabParentStore.selectedTabInfo;

  useIntersectionObserver({
    threshold: 0.7,
    target: firstCommentRef,
    onIntersect: () => {
      if (
        store.communicationTabParentStore.comments.length === 0 ||
        store.seenLastComment.value
      )
        return;
      store.communicationTabParentStore.handleSeenLastComment();
    },
  });

  return (
    <TabPanel px="0">
      <Box>
        <Box ref={store.commentsContainerRef}>
          {store.communicationTabParentStore.comments.map((comment, index) =>
            index === 0 ? (
              <CommentAppearance key={comment.id} commentId={comment.id}>
                <Comment
                  ref={firstCommentRef}
                  comment={comment}
                  onUpdated={
                    store.communicationTabParentStore.handleUpdateComment
                  }
                  onDeleted={
                    store.communicationTabParentStore.handleDeleteComment
                  }
                  taskId={store.task.value?.id}
                  colorScheme={USER_TYPE_TO_COLOR_SCHEME_MAP[userType]}
                  allowedMentions={userTypesWithAccess}
                />
              </CommentAppearance>
            ) : (
              <Comment
                key={comment.id}
                comment={comment}
                onUpdated={
                  store.communicationTabParentStore.handleUpdateComment
                }
                onDeleted={
                  store.communicationTabParentStore.handleDeleteComment
                }
                taskId={store.task.value?.id}
                colorScheme={USER_TYPE_TO_COLOR_SCHEME_MAP[userType]}
                allowedMentions={userTypesWithAccess}
              />
            ),
          )}
        </Box>
      </Box>
    </TabPanel>
  );
});
